"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isAlphanumeric = function (value) {
    var regex = /^[a-zA-Z0-9À-ÿ. ]+$/;
    return regex.test(value)
        ? false
        : 'Apenas letras (a-z), números (0-9), pontos e espaços podem ser utilizados neste campo';
};
exports.default = isAlphanumeric;
//# sourceMappingURL=isAlphanumeric.js.map